<template>
  <div
    class="middle_inner"
    v-if="
      this.$route.path === '/franchise' || this.$route.path === '/ru/franchise'
    "
  >
    <div class="franchise-page">
      <div class="middle_content entry" :style="contentExtraCss">
        <Notice v-if="$store.getters.notice">
          {{ $store.getters.notice }}
        </Notice>
        <Notice
          v-for="(notice, i) in $store.getters.notices"
          :key="`notice-${i}`"
        >
          {{ notice }}
        </Notice>
        <slot />
      </div>
    </div>
  </div>
  <div class="middle_inner" v-else>
    <div class="content_wrap fullwidth">
      <div class="middle_content entry" :style="contentExtraCss">
        <Notice v-if="$store.getters.notice">
          {{ $store.getters.notice }}
        </Notice>
        <Notice
          v-for="(notice, i) in $store.getters.notices"
          :key="`notice-${i}`"
        >
          {{ notice }}
        </Notice>
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
import Notice from '@/components/Notice'

export default {
  name: 'ContentWrapper',
  components: { Notice },
  computed: {
    contentExtraCss() {
      return this.$route.path.match(/\/product\//) ? 'padding-top:10px' : ''
    },
  },
}
</script>

<style>
.block {
  padding: 10px;
}
.block1 {
  background: yellow;
}
.block2 {
  background: rgb(127, 209, 116);
}
.middle_content {
  min-height: 400px;
}
</style>
